import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Modal from "../../UI/Modal/Modal";
import ModalHeader from "../../UI/Modal/ModalHeader";
import { ModalCloseButton } from "../../UI/StandardButtons/StandardButtons";
import InfoItems from "../../UI/InfoItems/InfoItems";
import DateService from "../../../Services/Shared/Date.service";
const PersonHighSchoolViewModal = (props) => {
    let rankSizeString = "";
    const rank = props.personHighSchool.rankPosition;
    const size = props.personHighSchool.rankClassSize;
    if (rank && size) {
        rankSizeString = rank + " / " + size;
    }
    else if (rank) {
        rankSizeString = rank + " / ?";
    }
    else if (size) {
        rankSizeString = "? / " + size;
    }
    const gpaString = props.personHighSchool.gpa
        ? props.personHighSchool.gpa.toFixed(2)
        : "";
    let attendedDateString = "";
    const attendedStartDate = "";
    const attendedEndDate = "";
    if (attendedStartDate && attendedEndDate) {
        attendedDateString = attendedStartDate + " - " + attendedEndDate;
    }
    else if (attendedStartDate) {
        attendedDateString = attendedStartDate + " - ?";
    }
    else if (attendedEndDate) {
        attendedDateString = "? - " + attendedEndDate;
    }
    let yearAttendedString = "";
    const start = props.personHighSchool.yearAttendedStart;
    const end = props.personHighSchool.yearAttendedEnd;
    if (start && end) {
        yearAttendedString = start + " - " + end;
    }
    else if (start) {
        yearAttendedString = start + " - ?";
    }
    else if (end) {
        yearAttendedString = "? - " + end;
    }
    return (_jsxs(Modal, { isOpen: props.isOpen, onModalClosed: props.onModalClosed, children: [_jsx(ModalHeader, { title: _jsx(_Fragment, { children: props.personHighSchool.highSchool.name }) }), _jsxs("div", { className: "modal-body", style: {
                    marginBottom: "0px",
                    paddingBottom: "0px",
                }, children: [_jsx(InfoItems, { items: [
                            {
                                label: "Attended Date",
                                value: attendedDateString,
                            },
                            {
                                label: "Years Attended",
                                value: yearAttendedString,
                            },
                            {
                                label: "Graduation Type",
                                value: props.personHighSchool.highSchoolGraduationType.name,
                            },
                            {
                                label: "GPA",
                                value: gpaString,
                            },
                            {
                                label: "Credits Earned",
                                value: props.personHighSchool.creditsEarned,
                            },
                            {
                                label: "Class Rank / Size",
                                value: rankSizeString,
                            },
                            {
                                label: "Transcript Status",
                                value: props.personHighSchool.highSchoolTranscriptStatus.name,
                            },
                            {
                                label: "Transcript Date",
                                value: props.personHighSchool.highSchoolTranscriptDate &&
                                    DateService.display(props.personHighSchool.highSchoolTranscriptDate),
                            },
                            {
                                label: "Transcript Type",
                                value: props.personHighSchool.highSchoolTranscriptType.name,
                            },
                            {
                                label: "CEEB Code",
                                value: props.personHighSchool.highSchool.ceebCode,
                            },
                        ], numColumnsLg: 2 }), _jsx("div", { className: "modal-footer", children: _jsx(ModalCloseButton, { onClick: props.onModalClosed }) })] })] }));
};
export default PersonHighSchoolViewModal;
